import { SimulationDao } from '@app/dao/simulation/simulation.dao';
import { EaSimulationAvPackFormComponent } from '@app/forms/simulation/ea-simulation-av-pack-form/ea-simulation-av-pack-form.component';
import * as _ from 'lodash';
import { of, map, mergeMap } from 'rxjs';
import {
  Allocation,
  PackService,
  SimulationPack,
} from '../simulation-pack.service';

export class LifeInsurrancePackService implements PackService {
  constructor(private simulationDao: SimulationDao) {}
  type = 'life_insurance';
  template = {
    panelTitle: 'CHOISISSEZ VOTRE PACK PERFORMANT',
    tableTitle: 'Liste des supports',
    tableButtonText: 'Constituer mon allocation sur mesure',
    tableEmptyText: 'Allocation vide',
    tableAdjusmentText:
      'La répartition a été ajustée au plus proche de la répartition que vous désiriez',
  };

  customPack: SimulationPack = {
    name: 'Selection Manuelle',
    description:
      'Constituez vous-même votre allocation assurance-vie en choisissant vos supports parmis les meilleurs ',
    allocation: [],
    buttonText: 'Constituer mon allocation sur mesure',
  };

  packForm: any = EaSimulationAvPackFormComponent;

  getPacks(productId) {
    return this.simulationDao.getAuthentified().pipe(
      mergeMap(user => {
        if (!productId) return of([]);
        return this.simulationDao
          .getProductPacks('ASSURANCE_VIE', productId)
          .pipe(
            map(packs => {
              return _.map(packs, pack => {
                return {
                  ..._.omit(pack, 'supportList'),
                  id: pack.allocationModelId,
                  allocation: _.map(pack.supportList, allocation => {
                    return {
                      allocationPercentage: allocation.allocationPercentage,
                      name: allocation.name || '',
                      supportIsin: allocation.isinCode,
                    } as unknown as Allocation;
                  }),
                };
              });
            }),
          );
      }),
    );
  }
}
